import { I } from '@angular/cdk/keycodes';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { SafeUrlPipe } from 'app/pipes/safe-url.pipe';
import { DocumentoNegociableService } from 'app/services/documento-negociable/documento-negociable.service';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.scss'],
  providers: [
    SafeUrlPipe, MessagesTitles, MessagesGeneral, MessagesStatus
  ]
})
export class CargaMasivaComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @Input() dataEmpresa: any = [];
  @Output() cerrarPopUp: EventEmitter<boolean>;
  @Output() datos = new EventEmitter<Object[]>();
  public workbook;
  form: FormGroup;
  user: any;
  files: any[] = [];
  dataEnviar: any = {};
  filesB64: any;
  cantItems: number;
  arrayRepetidos: any = [];
  arrayAdjuntos: any = [];
  loading: boolean;
  view: boolean;
  ListFiltro: any = [];
  Codigo: any = 1;
  CantItemsSelect: number;
  fileContent: any;
  xml: string;
  xml2: JSON;
  documentoNegociableService: DocumentoNegociableService;
  proveedor: any = {};
  adquirente: any = {};
  disable: boolean;
  lastCuota: any;
  description: any;
  monedaElement: any;
  vnpp: any;
  Fecha_de_Pago: any;
  Fecha_Vencimiento: any;
  error1: boolean = false;
  error2: boolean = false;
  mensaje1: string;
  mensaje2: string;
  ListArrayTo: any = [];
  arrayCampos: any = [];
  ExcelFile: any = [];
  options: any[];
  filtroOptions: string;
  typeFile:string="";
  statusFile: any = [];
  public archivoEnBase64: string;
  constructor(private msgTitle: MessagesTitles,
    private injector: Injector,
    private msgStatus: MessagesStatus,
    private empresasService: EmpresasService) {

    this.documentoNegociableService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cerrarPopUp = new EventEmitter();
  }

  ngOnInit() {
    this.form = new FormGroup({
      firstName: new FormControl()
   });
    this.ListFiltro = ["xml", "excel"];
    this.options= [{label:'Excel',value:'excel'},{label:'Xml',value:'xml'}];
  }

  Guardar() {
    this.error1=false;
    this.error2=false;
    if (this.typeFile==="") {
      Swal.fire({
        title: this.msgTitle.Error,
        text: 'Debe seleccionar el tipo de archivo',
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    } else if (this.typeFile==="xml") {
      let index=0;
      this.ListArrayTo=[]
      for (let p of this.files) {
        if (p.type !== 'text/xml') {
          Swal.fire({
            title: this.msgTitle.Error,
            text: 'El archivo ' + p.name + ' no es text/xml',
            type: "warning",
            allowOutsideClick: false,
            heightAuto: false
          });
          return;
        }
        this.onChangeXML(p,index)
        this.aBinarioXML(this.files)
        index++;
      }
    } else if (this.typeFile==="excel") {
      if (this.files.length > 1) {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'Solo es posible subir un archivo excel',
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      }
      if (this.files[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        Swal.fire({
          title: this.msgTitle.Error,
          text: 'El archivo ' + this.files[0].name + ' no es excel',
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
        return;
      }
      this.onChangeExcel(this.files)
    }
  }
  onChangeXML(fileList: any,index:any): void {
    let file = fileList;
    let fileReader: FileReader = new FileReader();
    fileReader.onloadend = x => {
      this.fileContent = fileReader.result;
      this.xml = this.fileContent;
      try {
        this.xml2 = this.documentoNegociableService.toXml(this.xml);
        const rucAdquirente = this.xml2["AccountingCustomerParty"]["Party"][
          "PartyIdentification"
        ]["ID"].trim();
        const rucProveedor = this.xml2["AccountingSupplierParty"]["Party"][
          "PartyIdentification"
        ]["ID"].trim();
        this.validarEmpresa(rucAdquirente, rucProveedor,file,index);
      } catch (error1) {
        this.mensaje1 =
          "El documento adjuntado no es una Factura Electronica, selecciona otro";
        this.error1 = false;
        Swal.fire({
          title: "error",
          text: this.mensaje1,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });

      }
    };
    fileReader.readAsText(file)
  }
  crearArray(index:any) {
    this.disable = true;
    // Campos Obligatorios
    let serie = this.xml2["ID"];
    let SerieNumero = serie.split("-", 2);
    if (Array.isArray(this.xml2["InvoiceLine"])) {
      this.description = this.xml2["InvoiceLine"][0]["Item"]["Description"];
    } else {
      this.description = this.xml2["InvoiceLine"]["Item"]["Description"];
    }
    if (this.xml2["DocumentCurrencyCode"].trim() == 'USD') {
      // this.monedaElement = this.Label_id_dolares
      this.monedaElement = this.Label_id_dolares
    } else {
      // this.monedaElement = this.Label_id_soles
      this.monedaElement = this.Label_id_soles
    }
    if (Array.isArray(this.xml2["PaymentTerms"])) {
      if (this.xml2["PaymentTerms"][0]["PaymentMeansID"].trim() == 'Credito') {
        this.vnpp = this.xml2["PaymentTerms"][0]["Amount"].trim();
        let lastCuota = this.xml2["PaymentTerms"].pop();
        this.Fecha_de_Pago = lastCuota["PaymentDueDate"].trim();
        this.Fecha_Vencimiento = lastCuota["PaymentDueDate"].trim();
      } else {
        this.vnpp = this.xml2["PaymentTerms"][0]["Amount"].trim();
        this.Fecha_de_Pago = this.xml2["IssueDate"].trim();
        this.Fecha_Vencimiento = this.xml2["IssueDate"].trim();
      }
    } else {
      this.vnpp = this.xml2["LegalMonetaryTotal"]["PayableAmount"].trim();
      this.Fecha_de_Pago = this.xml2["IssueDate"].trim();
      this.Fecha_Vencimiento = this.xml2["IssueDate"].trim();
    }

    this.arrayCampos = {
      Fecha_Emision: this.xml2["IssueDate"].trim(),
      Serie: SerieNumero[0].trim(),
      Numero: Number(SerieNumero[1].trim()),
      Descripcion: this.description,
      Moneda: (this.xml2["DocumentCurrencyCode"].trim()=='PEN')? 640:442,
      Valor_Venta: this.xml2["LegalMonetaryTotal"]["LineExtensionAmount"].trim(),
      Precio_Venta: this.xml2["LegalMonetaryTotal"]["PayableAmount"].trim(),
      IGV_Importe: this.xml2["TaxTotal"]["TaxAmount"].trim(),
      VNPP: this.vnpp,
      Fecha_de_Pago: this.Fecha_de_Pago,
      Fecha_Entrega: this.Fecha_de_Pago,
      Fecha_Vencimiento: this.Fecha_Vencimiento,
      idAdquirente: this.adquirente.idEmpresa,
      rucAdquirente: this.adquirente.Num_Doc_Identificacion,
      razSocial: this.adquirente.Razon_Social,
      dirFiscal: this.adquirente.Direccion_Fiscal,
      departamento: this.adquirente.Departamento,
      provincia: this.adquirente.Provincia,
      distrito: this.adquirente.Distrito,
      idProveedor: this.proveedor.idEmpresa,
      rucProveedor: this.proveedor.Num_Doc_Identificacion,
      razSocialProveedor: this.proveedor.Razon_Social,
      dirFiscalProveedor: this.proveedor.Direccion_Fiscal,
      departamentoProveedor: this.proveedor.Departamento,
      provinciaProveedor: this.proveedor.Provincia,
      distritoProveedor: this.proveedor.Distrito,
    };
    this.ListArrayTo.push(this.arrayCampos);
    this.DataXML(this.ListArrayTo,index)
  }
  DataXML(result:any,index:any){
    if(this.files.length===index+1){
      this.loading = false;
      if(this.error1===false&&this.error2===false){
        this.Enviar(result);
      }

    }
  }
  validarEmpresa(ruc: string, idProveedor: string,file:any,index) {
    this.adquirente = {};
    this.loading = true;
    this.documentoNegociableService.validarEmpresaExistenteADQ(ruc).subscribe(
      data => {
        /*if (data == null|| data.length == 0||data==='undefined') {
          
          this.error1 = true;
          if(file.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
            this.mensaje1 = "El "+this.Label_Adquirente.toLowerCase()+" de la fila "+(index+1)+" no existe.";
          }else{
            this.statusFile[index].value=true;
            this.mensaje1 = "El "+this.Label_Adquirente.toLowerCase()+" del documento "+file.name+" no existe.";
          }
          this.loading = false;
          Swal.fire({
            title: "error",
            text: this.mensaje1,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
          return;
        } else {
          this.adquirente = data;
          this.loading = false;
          if (this.adquirente.Estado == "X") {
            this.error1 = true;
            if(file.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
              this.mensaje1 =this.Label_Adquirente+" bloqueado en la fila "+(index+1);
            }else{
              this.statusFile[index].value=true;
              this.mensaje1 = this.Label_Adquirente+" bloqueado en el documento "+file.name;
            }
            Swal.fire({
              title: "error",
              text: this.mensaje1,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          } else {
            this.validarProveedor(idProveedor,file,index)
          }


        }*/
        this.validarProveedor(idProveedor,file,index)
      }
    );
  }
  validarProveedor(idProveedor: string,file:any,index) {
    this.proveedor = {};
    this.loading = true;
    this.documentoNegociableService.validarEmpresaExistente(idProveedor).subscribe(
      data => {
        if (data == null|| data.length == 0||data==='undefined') {
          this.loading = false;
          this.error2 = true;

          if(file.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
            this.mensaje2 = "El "+this.Label_Proveedor.toLowerCase()+" de la fila "+(index+1)+" no existe.";
          }else{
            this.statusFile[index].value=true;
            this.mensaje2 = "El "+this.Label_Proveedor.toLowerCase()+" del documento "+file.name+" no existe.";
          }
          Swal.fire({
            title: "error",
            text: this.mensaje2,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
          return;
        } else {
          this.proveedor = data;
          
          if (this.proveedor.Estado == "X") {
            this.loading = false;
            this.error2 = true;
            if(file.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
              this.mensaje2 = this.Label_Proveedor+" bloqueado en la fila "+(index+1);
            }else{
              this.statusFile[index].value=true;
              this.mensaje2 = this.Label_Proveedor+" bloqueado en el documento "+file.name;
            }
            Swal.fire({
              title: "error",
              text: this.mensaje2,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
            return;
          } else if(file.type==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            /* this.error2 = false; */
            console.log('aprobado');
            this.DataExcel(index);

          }else{
            /* this.error2 = false; */
            this.loading = false;
            this.crearArray(index);
          }
        }
      },
    );
  }
  aBinarioXML(fileList: any) {
    
    let file = fileList[0];

    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload = function (fileLoadedEvent) {
      base64 = fileLoadedEvent.target['result'];
      archivo64 = base64.split(',', 2);
      self.archivoEnBase64 = archivo64[1];
    };
    fileReader.readAsDataURL(file);


  }
  Enviar(dataEnviar: any) {
    let data = {
      "Alta_Canal":"W",
      "Alta_Usuario":this.user.Usuario, 
      "items":[]
    }

    data.items = dataEnviar;
    console.log("resultado",data)
     Swal.fire({
      title: "Espere",
      text: "Guardando Archivos",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.documentoNegociableService.cargaMasiva(data,this.typeFile)
      .subscribe(
        res => {
          Swal.fire({
            title: "Success",
            text: "Archivos registrados correctamente",
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then(resp => {
            if (resp.value) {
              this.files = [];
            }
          });
        }, (err: HttpErrorResponse) => {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
            this.msgStatus.getMessage(err.status);
          } else {
            this.msgStatus.getMessage(err.status);
          }

          Swal.fire({
            title: this.msgTitle.Error,
            text: "Archivos no guardados. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
        }
      ); 
  }
  cargarFiltro(event) {
    if(event.value==="excel"){
     this.typeFile="excel"
    }else{
      this.typeFile="xml"
    }
  }
  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  DataExcel(index:any){
    if(this.ExcelFile.length===index+1){
      this.loading = false;
      if(this.error1===false&&this.error2===false){
        this.Enviar(this.ExcelFile);
      }

    }
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.statusFile.splice(index,1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
      this.statusFile.push({value:false})
    }
    console.log('estadus de archivos',this.files)
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  CerrarVentana() {
    this.cerrarPopUp.emit();
  }

  onChangeExcel(fileList: any) : void {
    let file=fileList[0];
    this.files=fileList;
    let index=0;
    let fileReader = new FileReader();
    fileReader.readAsBinaryString(fileList[0]);
    fileReader.onload = (e) => {
      var workBook = XLSX.read(fileReader.result, { type: 'binary' });
      var sheetNames = workBook.SheetNames;
        this.ExcelFile = XLSX.utils.sheet_to_json(workBook.Sheets[sheetNames[0]]);
        
        for (let excel of this.ExcelFile) {
        let rucAdquirente = excel.rucAdquirente;
        let rucProveedor = excel.rucProveedor;
        this.validarEmpresa(rucAdquirente, rucProveedor,file,index);
      index++;
    }
    } 
  };
}

